import React from 'react';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';
import { Typography, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CustomButton from 'components/CustomButton'; // or MUI's Button

const getOptionsForField = (fieldName) => {
  if (fieldName === "publishOn") {
    return [
      { label: "Now", value: dayjs().toISOString() },
      { label: "After 24 hours", value: dayjs().add(24, 'hour').toISOString() }
    ];
  } else {
    return [
      { label: "Never", value: dayjs().set('year', 9999).endOf('year').toISOString() },
      { label: "After 1 week", value: dayjs().add(1, 'week').endOf('day').toISOString() }
    ];
  }
};

export default function MockDatePicker({ name, label, value, onChange, disabled, minDate }) {
  const [openDatePicker, setOpenDatePicker] = React.useState(false);
  const options = React.useMemo(() => getOptionsForField(name), [name]);

  const handleOptionChange = (event) => {
    onChange(name, event.target.value);
  };

  const handleDatePickerChange = (newValue) => {
    if (newValue) {
      onChange(name, newValue.toISOString());
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap='8px'>
      <Typography variant="body01-bold">{label}</Typography>
      <Box display="flex" alignItems="center">
        <RadioGroup
          row
          value={value}
          onChange={handleOptionChange}
          name={`${name}-options`}
          sx={{ gap: 1.5 }}
        >
          {options.map((opt) => (
            <FormControlLabel
              key={opt.value}
              value={opt.value}
              control={<Radio sx={{padding : 0 , marginRight : '4px'}} disabled={disabled} />}
              label={<Typography variant="body01-bold" color='primary.main'>{opt.label}</Typography>}
              sx={{
                m: 0,
                p : '8px 16px',
                border: '1px solid #003E8C',
                borderRadius: '999px',
                '& .MuiTypography-root': { textTransform: 'none' }
              }}
            />
          ))}
        </RadioGroup>

        <CustomButton
          style={{ borderRadius: 999, marginLeft: 8 }}
          size="large"
          startIcon={<CalendarIcon />}
          variant={value ? "contained" : "outlined"}
          onClick={() => setOpenDatePicker(true)}
          disabled={disabled}
        >
          {value ? (
            dayjs(value).format("DD MMM YYYY h:mm A")
          ) : (
            "Pick date and time"
          )}
        </CustomButton>

        <div style={{ visibility: 'hidden', height: 0, width: 0, overflow: 'hidden' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDateTimePicker
              open={openDatePicker}
              onClose={() => setOpenDatePicker(false)}
              value={value ? dayjs(value) : null}
              onChange={handleDatePickerChange}
              minDate={minDate ? dayjs(minDate) : undefined}
              disabled={disabled}
              renderInput={() => <></>} // hidden
              disablePast
            />
          </LocalizationProvider>
        </div>
      </Box>
    </Box>
  );
}
